angular
  .module('capability-ng-scheduler')
  .service(
    'saveStudentAvailabilityCommand',
    function saveStudentAvailabilityCommandDefinition(defineCommand, $http, calendarTimeFn) {
      return defineCommand(
        'saveStudentAvailabilityCommand',
        function saveStudentAvailabilityCommand(deferred, termId, time) {
          time = _.isArray(time) ? _.first(time) : time;

          if (!termId) {
            deferred.resolve();
            return;
          }

          $http
            .post('reg/preference/term/' + termId + '/availability/', {
              timeslot: calendarTimeFn.exportTime(time)
            })
            .then(function (response) {
              time.id = response.data.id;
              deferred.resolve(response.data);
            })
            .catch(function (e) {
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/student_availability/commands/save_student_availability_command.js